var _path, _path2, _path3, _path4, _path5, _circle, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperienceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5C4.42399 15.5 4.68474 15.1684 4.81968 14.9401C4.9744 14.6783 5.0964 14.3328 5.19218 13.9497C5.38566 13.1758 5.5 12.1331 5.5 11C5.5 9.86686 5.38566 8.82421 5.19218 8.05031C5.0964 7.6672 4.9744 7.32169 4.81968 7.05992C4.68474 6.83163 4.42399 6.5 4 6.5C3.57601 6.5 3.31526 6.83163 3.18032 7.05992C3.0256 7.32169 2.9036 7.6672 2.80782 8.05031C2.61434 8.82421 2.5 9.86686 2.5 11C2.5 12.1331 2.61434 13.1758 2.80782 13.9497C2.9036 14.3328 3.0256 14.6783 3.18032 14.9401C3.31526 15.1684 3.57601 15.5 4 15.5Z",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.5C20.4127 15.5 20.6723 15.1832 20.8108 14.9539C20.9675 14.6942 21.0928 14.3472 21.1922 13.9497C21.3925 13.1483 21.5 12.0878 21.5 11C21.5 9.91223 21.3925 8.8517 21.1922 8.0503C21.0928 7.65275 20.9675 7.30583 20.8108 7.04612C20.6723 6.81677 20.4127 6.5 20 6.5",
    stroke: "#222222",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6.5C20 6.5 16.5 7.5 12 7.5C7.5 7.5 4 6.5 4 6.5",
    stroke: "#33363F",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5C4 15.5 6.5044 14.7845 10 14.5639M20 15.5C20 15.5 17.4956 14.7845 14 14.5639",
    stroke: "#33363F",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 7.5V11M13.5 7.5V11",
    stroke: "#33363F",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 13,
    r: 2.5,
    stroke: "#222222"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14.5L7.5 16.5L9 17L10 18.5L12 15.5L14 18.5L15 17L16.5 16.5L14 14.5",
    stroke: "#33363F",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperienceIcon);
export default __webpack_public_path__ + "static/media/ExperienceIcon.0785b2bb46aed3e486547307271ee114.svg";
export { ForwardRef as ReactComponent };